<!--
* UIID: UI-DLB-MBL-130
* UI Name: Mapper List
* Modify Date: 2020/07/15
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <v-card-title
        class="headline white--text"
        primary-title
      >{{$t('lbl.mapBuilder.mapperList.mapperListHeader')}}</v-card-title>
    </template>
    <template v-slot:button-close>
      <!-- <v-icon class="ma-2" small @click="removeDialog" color="white">fas fa-times</v-icon> -->
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <!-- [E]  Popup title-->
    <v-card-text class="data-section pa-0 pr-8 pl-8 mr-0">
      <!-- [S]  Data Section-->
      <v-row class="ma-0 map-pb-search">
        <v-col cols="5" class="pa-0" v-if="customerSelect"></v-col>
        <v-col cols="8" class="pa-0" v-else></v-col>
        <v-col cols="3" class="map-popup-info" v-if="customerSelect">
          <v-label>{{$t('lbl.mapBuilder.mapperList.customerSearchTitle')}}</v-label>
          <div class="map-dv-select">
            <v-select
              v-model="filterItems.cus"
              :items=" customerItems"
              @change="filterMapList"
              height="30"
              solo
              dense
            ></v-select>
          </div>
        </v-col>
        <v-col cols="1" class="map-popup-locked">
          <v-label>{{$t('lbl.common.lockerTitle')}}</v-label>
          <div class="map-dv-select-locked">
            <v-select
              v-model="filterItems.locked"
              :items="lockedItems"
              @change="filterMapList"
              height="30"
              solo
              dense
            ></v-select>
          </div>
        </v-col>
        <v-col cols="3" class="pt-0 pb-0 pr-0 map-search">
          <v-text-field
            v-model="filterItems.search"
            @input="filterMapList"
            @click:append="filterMapList"
            @keyup.enter="filterMapList"
            class="search-matched-map-list-button custom-form-component search-button"
            placeholder="Search"
            outlined
            dense
            solo
            hide-details
            append-icon="fas fa-search"
            height="30"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row class="ma-0">
        <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
        <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
        <v-col cols="12" class="pt-0 pr-0 pb-0 pl-0">
          <v-data-table
            :headers="SummDataList.headers"
            :items="mapList"
            :items-per-page="-1"
            :hide-default-footer="true"
            :disable-sort="true"
            class="map-list-table pb-0"
            fixed-header
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.ROWID">
                  <td class="map-name-col">{{ item.MAP_NAME }}</td>
                  <td class="locked-col">
                    <v-icon
                      v-if="item.MAP_MAPP_CHKIN_YN === 'Y' "
                      small
                      @click.native="releaseLockedMap(item,'MAPP')"
                    >fas fa-check-square</v-icon>
                    <v-icon v-if="item.MAP_MAPP_CHKIN_YN === 'N' " small>far fa-window-close</v-icon>
                  </td>
                  <td class="map-name-col">{{ item.MAPPER_NAME }}</td>
                  <td class="version-col">
                    <a class="link-file-text" @click="openMapperVersion(item)">{{item.MAPP_VER}}</a>
                  </td>
                  <td class="customer-col">{{ item.MST_CUST_NM }}</td>
                  <td class="date-col no-wrap">
                    <span>{{ item.MAP_UPD_DT }}</span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <!-- [E]  Data Section-->
    </v-card-text>
    <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
    <v-row class="ml-0 mr-0">
      <v-col class="button-col action-col" lg="12">
        <div class="btn-form-control text-right mr-4">
          <v-btn class="btn btn-delete" @click="removeDialog">{{$t('btn.common.close')}}</v-btn>
        </div>
      </v-col>
    </v-row>
    <dialogWindow
      ref="warningCheckedOutMapperDialog"
      size="max"
      :detail="$t('msg.common.warning.detailWarningReleaseLocked',['mapper',updateUserId, 'Mapper'])"
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
/* globals Store */

import DialogDrag from "@/vue-dlb/components/vue-dialog-drag.vue";
import { mapState } from "vuex";
import $ from "jquery";
import cfg from "@/vue-caas/config/config.js";
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import IconSvg from "@/vue-caas/components/IconBase.vue";

/* 2020/11/11 203737 Remove unused source
import {
  showSuccessMessage,
  showErrorMessage,
  showProgress,
  hideProgress,
  alertSuccess,
  closeAlert
} from "@/vue-dlb/utils/sys-util.js";*/

export default {
  components: {
    DialogDrag,
    SystemProgress,
    dialogWindow,
    IconSvg,
  },
  name: "maplist-dialog",
  /* 2020/10/29 203737 Change prop definitions
  props: ['id', 'title', 'options', 'eventCb','selectFile', 'closeDialog', 'dragStart', 'dragEnd', 'queryList','fileSelected'],*/
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  computed: {
    ...mapState("mapbuilder", {
      mapList: "mapList",
      appliedList: "appliedList",
    }),
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
  },
  data() {
    return {
      /* 2020/11/11 203737 Remove unused source
      overlay: false,
      absolute: true,
      isActive: true,
      srmData:'',
      flatFileVersionHistoryItem: null,
      userRow: 'admin',
      search: '',
      selected_map:'',*/
      mapData: [],
      customerSelect: false,
      masterSearchItems: {
        header: ["ADMIN_YN", "CUST_ID", "LOCK_YN", "MAP_PRCS_NO"],
        data: [
          {
            ADMIN_YN: "",
            CUST_ID: "",
            LOCK_YN: "",
            MAP_PRCS_NO: "",
          },
        ],
      },
      filterItems: {
        cus: "",
        locked: "",
        search: "",
        CheckScanner: false,
      },
      SummDataList: {
        headers: [
          { text: "Map Name", value: "MAP_NAME" },
          { text: "Locked", value: "MAP_MAPP_CHKIN_YN" },
          { text: "Mapper", value: "MAPPER_NAME" },
          { text: "Version", value: "MAPP_VER" },
          { text: "Customer", value: "MST_CUST_ID" },
          { text: "Update Date", value: "MAP_UPD_DT" },
        ],
      },
      /* 2020/11/11 203737 Remove unused source
      SRMList: {
        headers: [      
          { text: this.$t('tbl.mapBuilder.srmList.sender'), value: 'SRM_SNDR'},   
          { text: this.$t('tbl.mapBuilder.srmList.receiver'), value: 'SRM_RCVR' },
          { text: this.$t('tbl.mapBuilder.srmList.message'), value: 'SRM_MSG_ID' },         
        ],
        dataItems:[]
      },*/
      lockedItems: [
        { text: "All", value: "" },
        { text: "Y", value: "Y" },
        { text: "N", value: "N" },
      ],
      customerItems: [
        { text: "All", value: "" },
        { text: "Customer", value: "ENDUSER" },
        { text: "Admin", value: "ADMIN" },
      ],
      releaseLockItems: {
        header: ["MAP_KIND", "MAP_PRCS_NO", "LOCK_YN"],
        data: [
          {
            MAP_KIND: "",
            MAP_PRCS_NO: "",
            LOCK_YN: "N",
          },
        ],
      },
      arrLayoutDialog: [],
      dialogs: [],
      dialogId: 1,
      isLoading: true,
      currentUserId: "",
      updateUserId: "",
    };
  },
  created() {
    this.queryMapList();
    if ($cookies.get("comp-id") == cfg.provider) {
      this.customerSelect = true;
    }
    /* 2020/10/29 203737 Remove unused source
    if(this.fileSelected !== undefined && this.fileSelected !== null){
        this.selected_map = this.fileSelected;
    }*/
  },
  /* 2020/10/28 203737 Remove unused source
  mounted() {
    // $('body').click((event) => {
    //   this.closeTbOverlay();
    // });
  },
  watch: {
  },*/
  methods: {
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    releaseLockedMap(item, type) {
      let isCheckedOut = this.getIsCheckedOut(item, type);
      if (isCheckedOut && type === "MAPP") {
        this.$refs.warningCheckedOutMapperDialog.dialog = true;
        return;
      }
      this.releaseLockItems.data[0].MAP_KIND = type;
      this.releaseLockItems.data[0].MAP_PRCS_NO = item.MAP_PRCS_NO;
      Store.dispatch("map/updateLock", this.releaseLockItems).then(() => {
        this.queryMapList();
      });
    },
    queryMapList() {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      //[2020-04-17] apply by CLV: Apply srmlist/queryMapList api
      console.log("--------- getSummaryList ----------");
      this.masterSearchItems.data[0].ADMIN_YN = $cookies.get("used-repo");
      if ($cookies.get("comp-id") == cfg.provider) {
        //only available for CLT Company, Super Admin
        this.masterSearchItems.data[0].CUST_ID = "ALL"; // TBD - April. After get API from CASS to search customer, Change here.
      } else {
        this.masterSearchItems.data[0].CUST_ID = $cookies.get("comp-id");
      }
      this.masterSearchItems.data[0].LOCK_YN = "";
      this.masterSearchItems.data[0].MAP_PRCS_NO = "";
      Store.dispatch("mapbuilder/queryMapList", this.masterSearchItems)
        .then(() => {
          console.log("--------- Finished to process ----------");
          console.log(this.mapList);
          console.log(this.appliedList);
          this.mapData = this.mapList;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterMapList() {
      Store.commit("mapbuilder/SET_MAP_FILTER", this.filterItems);
    },
    openMapperVersion(itemRow) {
      let isCheckedOut = this.getIsCheckedOut(itemRow, "MAPP");
      itemRow.isCheckedOut = isCheckedOut;
      this.$emit("openMapperVersion", itemRow);
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = "Dialog " + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, options };
    },
    removeDialogVersion(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    /* 2020/10/28 203737 Remove unused source
    dialogDragEndVersion (obj) {
      let index = this.findDialog(obj.id)
      this.$set(this.dialogs[index].options, 'left', obj.left)
      this.$set(this.dialogs[index].options, 'top', obj.top)
    },
    selectDialogVersion (obj) {
      let index = this.findDialog(obj.id)
      this.selected = this.dialogs[index]
    },*/
    getIsCheckedOut(itemRow, type) {
      let isCheckedOut = false;
      this.currentUserId = $cookies.get("user-id");
      this.updateUserId = itemRow.MAP_UPD_USR;
      let isLocked;

      if (type === "MAPP") {
        isLocked = itemRow.MAP_MAPP_CHKIN_YN === "Y" ? true : false;
      } else {
        isLocked = itemRow.MAP_SCAN_CHKIN_YN === "Y" ? true : false;
      }

      if (this.currentUserId !== this.updateUserId && isLocked) {
        isCheckedOut = true;
      }
      return isCheckedOut;
    },
  },
};
</script>